import { computed, MaybeRefOrGetter, toRef } from 'vue';
import { truthy } from './helper';
import { isString } from 'lodash';

export type NamedGroup<T = any> = {
  name?: string | null;
  items?: Array<T> | null;
};

export function useNamedGroups<T>(groups: MaybeRefOrGetter<NamedGroup<T>[] | undefined>) {
  const groupsRef = toRef(groups);

  const allEntries = computed<T[] | undefined>(() =>
    groupsRef.value?.flatMap((group: NamedGroup) => group.items).filter(truthy),
  );

  const numGroups = computed(() => groupsRef.value?.length ?? 0);

  const groupRecord = computed(() =>
    groupsRef.value
      ? Object.fromEntries<T[]>(
          groupsRef.value
            .filter(
              (group): group is { name: string; items: T[] } =>
                isString(group.name) && !!group.items?.length,
            )
            .map((group) => [group.name, group.items]),
        )
      : undefined,
  );

  return {
    allEntries,
    groupRecord,
    numGroups,
  };
}
